import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyInfo, setDropdownEmployeeList, setIsLoading } from "../slices/adminCompanySlice";
import * as service from "../services/adminApi";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { message, Modal } from "antd";
import useAdminCompany from "./useAdminCompany";

const useAdminDetail = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch()
    const { companyInfo, dropdownEmployeeList } = useSelector((state) => state.adminCompany);
    const { currentEmployee, currentCompany } = useSelector((state) => state.company)
    const [craditisModalOpen, setcraditIsModalOpen] = useState(false);

    const { onSelectCompany } = useAdminCompany();

    const getDropdownEmployee = useCallback(async (params) => {
        dispatch(setIsLoading(true))
        await service.dropdownEmployee({
            ...params,
            companyId: currentCompany,
            employeeId: currentEmployee
        }).then((res) => {
            dispatch(setDropdownEmployeeList(res?.data || []))
        }).catch((error) => {

        }).finally((o) => {

            dispatch(setIsLoading(false))
        })
    }, [dispatch, currentCompany, currentEmployee])

    const employeeOptions = useMemo(() => {
        return dropdownEmployeeList?.map((o) => {
            return {
                ...o,
                label: i18n.language === 'en' ? o?.fullNameEn : o?.fullName,
                value: o?.id
            }
        })
    }, [dropdownEmployeeList, i18n.language])

    useEffect(() => {
        if (currentCompany) {
            getDropdownEmployee();
            onSelectCompany(currentCompany);
        }
    }, [currentCompany])

    const updateAdminCompanyInfo = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                const response = await service.updateCompanyAdmin(
                    ({
                        ...values,
                        stpCompanyId: currentCompany,
                        employeeId: currentEmployee,
                        startDate: dayjs(values?.startDate)?.format("YYYY-MM-DD"),
                    })
                );
                message.success(t("common.success"))

            } catch (error) {
                message.error(t("common.error"))
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, currentEmployee, currentCompany]
    );

    const onUpdateAdminCompanyInfo = useCallback(
        (values, onSuccess) => {
            Modal.confirm({
                title: t('dialog.confirmation.header'),
                content: (
                    <>
                        <p>{t('generaInfo.are-you-sure-confirm-to-edit')}</p>
                    </>
                ),
                onOk() {
                    updateAdminCompanyInfo(values).then(() => {
                        if (onSuccess) onSuccess();
                    });
                },
                okText: t('confirm'),
                cancelText: t('generalInfo.cancel'),
            });
        },
        [updateAdminCompanyInfo]
    );

    const updateStatusAdminCompany = useCallback(
        async ({ status }) => {
            try {
                const res = await service.enabledAdminCompany({
                    companyId: currentCompany,
                    status: status,
                });

                dispatch(setCompanyInfo({
                    ...companyInfo,
                    statusFlag: status,
                }));
                message.success(t("common.success"))
            } catch (error) {
                message.error(t("common.error"))
            }
        },
        [dispatch, companyInfo, currentCompany]
    );

    const onUpdateAdminCompanyStatusFlag = useCallback(
        (status) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: i18n.language === "en" ? (
                    <p>Are you sure confirm to change status ?</p>
                ) : (
                    <p>คุณยืนยันการเปลี่ยนสถานะใช่หรือไม่ ?</p>
                ),
                onOk() {
                    updateStatusAdminCompany({ status });
                },
                okText: t("confirm"),
                cancelText: t("generalInfo.cancel"),
            });
        },
        [updateStatusAdminCompany, t]
    );

    return {
        companyInfo,
        employeeOptions,
        onUpdateAdminCompanyInfo,
        onUpdateAdminCompanyStatusFlag,
        getDropdownEmployee,
        setcraditIsModalOpen,
        craditisModalOpen
    };
};
export default useAdminDetail; 